import { Sentry } from "./sentryInstrument";
import { handleSiteModal } from "./util/modalHelperFunctions";

const dialogs = document.querySelectorAll(".popity");
const popityContainer = document.getElementById("popity-container");
let isOpenDialogPresent;


// fetch URL Contents
async function fetchPopity() {
  const params = location.search ? location.search + "&ref=" + document.referrer : "?ref=" + document.referrer;
  try {
    const response = await fetch("/ads/popity.html" + params);
    if (response.ok) {
      return response.text();
    } else {
      console.log("There was an error: " + response.status);
	  return "";
    }
  } catch (error) {
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Sentry is not initialized", error);
    }
    return "";
  }
}


// Safely open a modal, catching any errors from showModal()
function safeOpenModal(popity) {
  try {
    handleSiteModal(popity, "open");
  } catch (error) {
    // showModal() can throw if dialog is invalid or already open
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Failed to open popity modal", error);
    }
  }
}

// detect if any other dialog modals are open
function openDialogsPresent(popity) {
  isOpenDialogPresent = false;

  dialogs.forEach((dialog) => {
    if (dialog.open) {
      isOpenDialogPresent = true;
    } 
  });

  if (isOpenDialogPresent) {
    setTimeout(() => openDialogsPresent(popity), 3000);
  } else {
    safeOpenModal(popity);
  }
}


document.addEventListener("DOMContentLoaded", () => {
  let modalOpened = false;

  if (popityContainer === null) {
    return;
  }

  fetchPopity().then(popityHTML => {
	const wrap = document.createElement("div");
    wrap.innerHTML = popityHTML;
	popityContainer.appendChild(wrap);
	for (const scriptEl of wrap.querySelectorAll("script")) {
	  const script = document.createElement("script");
	  script.innerHTML = scriptEl.textContent;
	  try {
		popityContainer.appendChild(script);
	  } catch (error) {
		if (error && (error instanceof SyntaxError || error.name === "SyntaxError")) {
		  if (Sentry && Sentry.captureException) {
			Sentry.captureException(error);
		  } else {
			console.error("Sentry is not initialized", error);
		  }
		  if (script.parentNode === popityContainer) {
			popityContainer.removeChild(script);
		  }
		  continue;
		} else {
		  throw error;
		}
	  }
	}

    const popities = document.querySelectorAll(".popity");
    popities.forEach((popity) => {
      const popityID = Number(popity.dataset.id);
      if (!modalOpened) {
  
        // trigger functionality
        const popityTrigger = popity.dataset.trigger;
        
        if (popityTrigger === "load") {
  
          safeOpenModal(popity);
  
        } else if (popityTrigger === "3delay") {
  
          setTimeout(() => openDialogsPresent(popity), 3000);
  
        } else if (popityTrigger === "25scroll") {
  
          let modalScrollTriggered = false;
          window.addEventListener("scroll", () => {
            if (!modalScrollTriggered) {
              const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
              if (scrollPercentage >= 25) {
                safeOpenModal(popity);
                modalScrollTriggered = true;
              }
            }
          });
          
        }
        modalOpened = true; // prevents more than one popity modal from showing
      } 
    
    });

  }).catch(error => {
    // Catch any unhandled errors in the promise chain
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Error in popity initialization", error);
    }
  });
     
});


